import React, { useMemo } from 'react'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import { Card, CardBody, Heading, Skeleton, Text } from 'uikit'
import { useTranslation } from 'contexts/Localization'
import useGetStats from 'hooks/api'
import { useVaults, useMultiPool } from 'state/hooks'
import Balance from 'components/Balance'
import { BIG_ZERO } from 'utils/bigNumber'

const StyledTotalValueLockedCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background2};

  ${({ theme }) => theme.mediaQueries.lg} {
    margin: 0;
    max-width: none;
  }

  transition: opacity 200ms;
`

const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  width: 42px;
  height: 21px;

  background: #9112ff;
  border-radius: 4px;

  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0.19em;
`

const StyledHeading = styled(Heading)`
  font-weight: bold;
  font-size: 26px;
  margin-bottom: 8px;
`

const TvlBalance = styled(Balance)`
  font-weight: bold;
  font-size: 32px;
  color: #fefacd;
`

const StyledText = styled(Text)`
  font-weight: 300;
  font-size: 15px;
  color: #fefacd;
`

const TotalValueLockedCard = () => {
  const { t } = useTranslation()
  const tvlApi = useGetStats()
  const { data: vaults } = useVaults()
  const { data: multiPool } = useMultiPool()

  const tvlShow = useMemo(() => {
    let tvl = tvlApi ? new BigNumber(tvlApi) : BIG_ZERO
    vaults.forEach((vault) => {
      if (vault.tvl && !vault.tvl.isNaN()) {
        tvl = tvl.plus(vault.tvl)
      }
    })
    if (multiPool.tvlUsd && !multiPool.tvlUsd.isNaN()) {
      tvl = tvl.plus(multiPool.tvlUsd)
    }
    return tvl.toNumber()
  }, [tvlApi, vaults, multiPool.tvlUsd])

  return (
    <StyledTotalValueLockedCard isSecondary>
      <CardBody>
        <Tag>{t('TVL')}</Tag>
        <StyledHeading>{t('Total Value Locked')}</StyledHeading>
        {tvlShow ? (
          <>
            <TvlBalance decimals={2} value={tvlShow} prefix="$" />
          </>
        ) : (
          <Skeleton height={48} width={240} />
        )}
        <StyledText>{t('Across all LPs and Pools')}</StyledText>
      </CardBody>
    </StyledTotalValueLockedCard>
  )
}

export default TotalValueLockedCard
